import { Builder } from '@builder.io/react';
import PrimaryButton from './PrimaryButton';

Builder.registerComponent(PrimaryButton, {
  name: 'PrimaryButton',
  inputs: [
    {
      name: 'buttonText',
      type: 'string',
      defaultValue: 'Click Me!',
    },
    {
      name: 'linkTo',
      type: 'string',
      defaultValue: '/',
      helperText: 'Set the URL the button will link to',
    },
  ],
});
